import { FormControl } from '@angular/forms';
import { Maestro_ConsultasParametros } from 'src/app/models/generic/Maestro_ConsultasParametros';
import { Item_Seleccion } from './Item_Seleccion';

export class GenerarConsultasParametrosDTO {
    parametro: Maestro_ConsultasParametros;
    valoresSeleccion: Item_Seleccion[];
    control: FormControl;
}